import styled from "styled-components";
import { FONT_WT_REGULAR } from "@website-builder/utilities-index";

export const PanelWrapper = styled.section`
	background-color: #fff;
	min-height: 300px;
	border: solid 1px #d8d8d8;
`;

export const Heading = styled.h2`
	background-color: var(--secondary);
	min-height: 56px;
	font-size: 22px;
	padding: 10px;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;
`;

export const ListWrapper = styled.ul`
	list-style: square;
	margin: 20px 0;
	padding-right: 20px;
	li {
		padding-bottom: 10px;
		font-size: 18px;
		a {
			color: inherit;
			text-decoration: none;
			&:hover {
				font-weight: ${FONT_WT_REGULAR};
			}
		}
	}
`;
